<div class="grid-smart-search-container d-flex align-items-center">
  <!--simple search-->
  @if (config && config.complex_search == undefined) {
    <span class="grid-smart-search" id="basic-addon2" (click)="onFilterClick(filterKey)"><i class="fa fa-search"
    aria-hidden="true"></i></span>
    <input type="text" [value]="filter" class="search form-control" id="search_value_input" [(ngModel)]="filterKey"
      [attr.placeholder]="config!=undefined && config.placeholder!=undefined &&config.placeholder? config.placeholder:'field.hint.search' | translate | async"
      (keydown)="onFilter($event)" (keydown.enter)="handleKeyEnter($event)">
    @if (filterKey!='') {
      <span class="grid-smart-search" id="basic-addon2"
        (click)="filterKey='';onFilterClick(filterKey)"><i class="fa fa-times" aria-hidden="true"></i></span>
      }
    }
    <!--complex search-->
    @if (config && config.complex_search != undefined) {
      @if (config && config.searchField != undefined && config.searchField != '') {
        <span class="complex-search-pill">
          <span class="selected-pill-item ng-star-inserted">{{config.searchField.label | translate | async}}
            @if (config.complex_search.length!=undefined && config.complex_search.length>1) {
              <a class="complex-search-pill-close"
                (click)="clearComplexSearch(search)"><i class="fa fa-angle-down"></i></a>
              }
            </span>
          </span>
        }
        @if (config && config.searchField != undefined && config.searchField != '' && config.searchField.datasource != undefined && config.inputSearch) {
          <div
            >
            <input-search id="inputDataGridElement" [data]="config.searchField" [value]="filterKey"
              [placeholder]="'field.label.search'| translate | async" (patientResult)="settingUserInfo($event)">
          </input-search>
        </div>
      }
      @if (config.inputSearch == undefined || !config.inputSearch) {
        <span class="grid-smart-search" id="basic-addon2" (click)="onFilterClick(filterKey)"><i class="fa fa-search"
        aria-hidden="true"></i></span>
        <input type="text" [value]="filter"
          [disabled]="config && (config.searchField == undefined || config.searchField == '')"
          class="search form-control" id="complex-search-input search_value_input" [(ngModel)]="filterKey"
          [placeholder]="'field.label.search_by'| translate | async" (keydown.enter)="handleKeyEnter($event)" autocomplete="off"
          (keydown)="onFilter($event)" (keyup)="onSearchKey($event);" #input>
        <!-- (click)="searchFields($event)" -->
      }
    }

    <ng-container>
      @if (getConvoxConfig()) {
        <span class="advsearchspan_search" (click)="getContactInfo('search_value_input');">
          <i aria-hidden="true" class="fa fa-phone"></i>
        </span>
      }
      @if (config && config.searchField && config.searchField.key && (config.inputSearch == undefined || !config.inputSearch)) {
        <span class="advsearchspan_search" (click)="hasQrCodeScanner();">
          <i aria-hidden="true" class="fa fa-qrcode"></i>
        </span>
      }
      @if (preferencesService.checkCommonConfigEnabled('voice_search') && (config.inputSearch == undefined || !config.inputSearch)) {
        <span class="advsearchspan_search"
          (click)="textToSpeech('search_value_input');">
          <i aria-hidden="true" class="fa fa-microphone"></i>
        </span>
      }
    </ng-container>
    @if (config.journey_info!=undefined && config.journey_info && filterKey!=undefined && filterKey && (config!=undefined && config.searchField!=undefined && config.searchField.key!=undefined &&(config.searchField.key=='UHID' || config.searchField.key=='uhId' || config.searchField.key=='uhid'))) {
      <span class="advsearchspan_search" (click)="redirect(config.journey_info);">
        <i aria-hidden="true" class="fa fa-file-archive-o"></i>
      </span>
    }
    @if (config && config.setSearchPopup) {
      <div class="complex-search-container">
        <div class="complex-search-body">
          @for (search of config.complex_search; track search) {
            <button type="button" class="p-dropdown-item"
              (click)="onSearchClicked(search)">
              {{search.label | translate | async}}
            </button>
          }
        </div>
      </div>
    }
  </div>
  @if (config.face_recognition != undefined && config.face_recognition && appService !=undefined && appService._face_recognition !=undefined && appService._face_recognition) {
    <div (click)="facerecognition()">
      <span _ngcontent-fpd-c109="" class="face-recognition-inline-button ng-star-inserted">
        <i _ngcontent-fpd-c109="" class="ng-star-inserted"></i><img src="/assets/images/icons/face-recognition-white.svg" width="30px" height="25px"></span>
      </div>
    }